var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"md":"8"}},[_c('v-img',{attrs:{"src":"/img/HealthViewCapital-ColorLogo.png","alt":"HealthView Capital Partners Logo","height":"165","contain":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }